import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { GeneralServicesImplService } from 'src/services/general-services-impl.service';
import { urls } from 'src/services/api/urls';
import * as servers from '../../../services/api/servers';
import { ProjectConstants } from 'src/app/project-constants';

@Injectable({
  providedIn: 'root'
})
export class ConsolidationService extends GeneralServicesImplService implements ProjectConstants {
  constructor(http: HttpClient) {
    super(http);
  }

 // baseUrl: string = servers.apiUrl + urls.cobidbService + urls.contractController;
  baseUrl: string = servers.apiUrl + urls.consolidationController;

  consolidate(url: string, object: any) {
    const body =  object ? JSON.stringify(object) : null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url + '/consolida', body, {headers: header, responseType: 'json'})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }
}
